import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    page: 0,
    size: 10
}

const paginationSlice = createSlice({
    name: 'pagination',
    initialState,
    reducers: {
        setPage: (state, action) => {
            state.page = action.payload
        },
        setSize: (state, action) => {
            state.size = action.payload
        },
        resetPage: (state) => {
            state.page = 0
        },
    }
})

export const { setPage, setSize, resetPage } = paginationSlice.actions
export default paginationSlice.reducer